import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import YeloLogo from '../../../components/Icons/YeloLogo';
import { DIGITAL_ACCOUNT_ROUTES } from '../../../constants/routes';
import { useCustomNavigate } from '../../../utils/customHooks/useCustomNavigate';

const StyledContainer = styled(Box)(({ theme }) => ({
  background: 'white',
  padding: '28px',
  minWidth: 0,
  boxSizing: 'border-box',
  [theme.breakpoints.down('md')]: {
    padding: '20px',
  },
}));

const ContainerLayout = (props: PropsWithChildren) => {
  const navigate = useCustomNavigate();
  const { pathname } = useLocation();

  const handleLogoClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const step = pathname.split('/').filter(Boolean).at(-1);
    navigate(`unregistered/${DIGITAL_ACCOUNT_ROUTES.base}/review?stage=${step}`);
  };

  return (
    <StyledContainer>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        <a onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          {' '}
          <YeloLogo />
        </a>
        {/* <LanguageSwitcher /> */}
      </Box>
      {props.children}
    </StyledContainer>
  );
};

export default ContainerLayout;
